import { FC, ReactNode } from 'react';
import { styled } from '@mui/material';
import { Stack, colors } from '@o2/ui';

export interface ControlsProps {
  children: ReactNode;
}

const StyledControls = styled(Stack, {
  name: 'AppBar',
  slot: 'Controls',
})(({ theme }) => ({
  height: '100%',
  marginLeft: theme.spacing(2),
}));

const StyledDivider = styled('hr', {
  name: 'AppBarControls',
  slot: 'Divider',
})(() => ({
  border: 'none',
  borderLeft: `1px solid ${colors.transparentGray[100]}`,
}));

const Controls: FC<ControlsProps> = ({ children, ...other }) => {
  /* TODO: Try implement Divider without using fragment */
  return (
    <StyledControls direction="row" spacing={0} divider={<StyledDivider />} {...other}>
      {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
      <></>
      {children}
    </StyledControls>
  );
};

Controls.displayName = 'AppBar.Controls';

export default Controls;
